import { PagingResultsViewModel, FilterSearchingBaseViewModel, Tc } from '../../core/_infrastructure/types/common';

/****  INFORME IMPORTACIONES  ****/

export class InformeImportacionesItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: InformeImportacionesItemViewModel[];
}

export class InformeImportacionesItemViewModel {
    public IdSolicitud: number;
    public Codigo: string;
    public CodigoTipoSolicitud: string;
    public NombreTipoSolicitudComplete: string;
    public IsPredua: boolean;
    public FechaEnvio: Date;
    public TipoSolicitud: string;
    public IdEstadoSolicitud: number;
    public EstadoSolicitud: string;
    public Zona: string;
    public Provincia: string;
    public PuntoInspeccion: string;
    public CodigoTaric: string;
    public CodigoEppo: string;
    public Grupo: string;
    public Forma: string;
    public NombreCientifico: string;
    public PaisOrigen: string;
    public PaisDestino: string;
    public PaisProcedencia: string;
    public Peso: number;
    public Unidades: number;
    public Volumen: number;

    //para las agrupaciones
    public CuentaSolicitudes: number;
    public Mes: number;
    public Año: number;
    public TotalPesoNeto: number;
    public TotalUnidades: number;
    public TotalVolumen: number;
}

export class FilterSearchingInformeImportacionesViewModel extends FilterSearchingBaseViewModel {
    public FechaDesde: Date | null;
    public FechaHasta: Date | null;
    public IdAgrupacionFechas: number;
    public IdAgrupacionFechasDescripcion: string;
    public IdTipoSolicitudCollection: number[] | null = [];
    public IdTipoSolicitudDescripcionCollection: string[] = [];
    public IdEstadoSolicitudCollection: number[] | null = [];
    public IdEstadoSolicitudDescripcionCollection: string[] = [];
    public IdLocalizacion: number | null;
    public IdLocalizacionDescripcion = '';
    public IdZona: number | null;
    public IdZonaDescripcion = '';
    public IdPuntoInspeccion: number | null;
    public IdPuntoInspeccionDescripcion = '';
    public IdPaisOrigenCollection: number[] | null = [];
    public IdPaisOrigenDescripcionCollection: string[] = [];
    public IdPaisOrigenGrupoPaisFrCollection: number[] = [];
    public IdPaisOrigenGrupoPaisFrDescripcionCollection: string[] = [];
    public IdPaisDestinoCollection: number[];
    public IdPaisDestinoDescripcionCollection: string[] = [];
    public IdPaisDestinoGrupoPaisFrCollection: number[] = [];
    public IdPaisDestinoGrupoPaisFrDescripcionCollection: string[] = [];
    public IdPaisProcedenciaCollection: number[];
    public IdPaisProcedenciaDescripcionCollection: string[] = [];
    public IdPaisProcedenciaGrupoPaisFrCollection: number[] = [];
    public IdPaisProcedenciaGrupoPaisFrDescripcionCollection: string[] = [];
    public IdGrupo: number | null;
    public IdGrupoDescripcion = '';
    public IdForma: number | null;
    public IdFormaDescripcion = '';
    public IdSubForma: number | null;
    public IdSubFormaDescripcion = '';
    public CodigoEppoCollection: number[] = [];
    public CodigoEppoDescripcionCollection: string[] = [];
    public CodigoTaric = '';

    public GenerarExcel = false;
}

export enum EnumIdsInformeImportacionesAgrupacionFechas {
    ID_SIN_AGRUPAR = 1,
    ID_MES = 2,
    ID_ANIO = 3,
}

export enum EnumIdsTcNacionalCanarias {
    ID_PENINSULA_Y_CANARIAS = 1,
    ID_PENINSULA = 2,
    ID_CANARIAS = 3,
}

/****  INFORME EXPORTACIONES  ****/

export class InformeExportacionesItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: InformeExportacionesItemViewModel[];
}

export class InformeExportacionesItemViewModel {
    public IdSolicitud: number;
    public Codigo: string;
    public CodigoTipoSolicitud: string;
    public NombreTipoSolicitudComplete: string;
    public IsPredua: boolean;
    public FechaEnvio: Date;
    public TipoSolicitud: string;
    public IdEstadoSolicitud: number;
    public EstadoSolicitud: string;
    public Zona: string;
    public Provincia: string;
    public PuntoInspeccion: string;
    public CodigoTaric: string;
    public CodigoEppo: string;
    public Grupo: string;
    public Forma: string;
    public NombreCientifico: string;
    public PaisOrigen: string;
    public PaisDestino: string;
    public PaisProcedencia: string;
    public Peso: number;
    public Unidades: number;
    public Volumen: number;

    //para las agrupaciones
    public CuentaSolicitudes: number;
    public Mes: number;
    public Año: number;
    public TotalPesoNeto: number;
    public TotalUnidades: number;
    public TotalVolumen: number;
}

export class FilterSearchingInformeExportacionesViewModel extends FilterSearchingBaseViewModel {
    public FechaDesde: Date | null;
    public FechaHasta: Date | null;
    public IdAgrupacionFechas: number;
    public IdAgrupacionFechasDescripcion: string;
    public IdTipoSolicitudCollection: number[] | null = [];
    public IdTipoSolicitudDescripcionCollection: string[] = [];
    public IdEstadoSolicitudCollection: number[] | null = [];
    public IdEstadoSolicitudDescripcionCollection: string[] = [];
    public IdLocalizacion: number | null;
    public IdLocalizacionDescripcion = '';
    public IdZona: number | null;
    public IdZonaDescripcion = '';
    public IdPuntoInspeccion: number | null;
    public IdPuntoInspeccionDescripcion = '';
    public IdPaisOrigenCollection: number[] | null = [];
    public IdPaisOrigenDescripcionCollection: string[] = [];
    public IdPaisOrigenGrupoPaisFrCollection: number[] = [];
    public IdPaisOrigenGrupoPaisFrDescripcionCollection: string[] = [];
    public IdPaisDestinoCollection: number[];
    public IdPaisDestinoDescripcionCollection: string[] = [];
    public IdPaisDestinoGrupoPaisFrCollection: number[] = [];
    public IdPaisDestinoGrupoPaisFrDescripcionCollection: string[] = [];
    public IdPaisProcedenciaCollection: number[];
    public IdPaisProcedenciaDescripcionCollection: string[] = [];
    public IdPaisProcedenciaGrupoPaisFrCollection: number[] = [];
    public IdPaisProcedenciaGrupoPaisFrDescripcionCollection: string[] = [];
    public IdGrupo: number | null;
    public IdGrupoDescripcion = '';
    public IdForma: number | null;
    public IdFormaDescripcion = '';
    public IdSubForma: number | null;
    public IdSubFormaDescripcion = '';
    public CodigoEppoCollection: number[] = [];
    public CodigoEppoDescripcionCollection: string[] = [];
    public CodigoTaric = '';

    public GenerarExcel = false;
}

export enum EnumIdsInformeExportacionesAgrupacionFechas {
    ID_SIN_AGRUPAR = 1,
    ID_MES = 2,
    ID_ANIO = 3,
}

// ESTO TIENE QUE ESTAR EN EXPORTACIONES ?//
export enum EnumIdsTcNacionalCanarias {
    ID_PENINSULA_Y_CANARIAS_EXP = 1,
    ID_PENINSULA_EXP = 2,
    ID_CANARIAS_EXP = 3,
}

/****  INFORME TASAS IMPORTACIÓN ****/

export class InformeTasasItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: InformeTasasImportacionItemViewModel[];
}

export class InformeTasasImportacionItemViewModel {
    public CodigoTipoSolicitud: string;
    public NombreTipoSolicitudComplete: string;
    public IsPredua: boolean;
    public TipoSolicitud: string;
    public IdEstadoSolicitud: number;

    public Provincia: string;
    public PuntoInspeccion: string;
    public RazonSocial: string;
    public FechaSolicitud: Date;
    public Codigo: string;
    public EstadoSolicitud: string;
    public TotalTasas: number;
    public NumeroLiquidacion: string;
    public FechaLiquidacion: Date | null;
}

export class FilterSearchingInformeTasasViewModel extends FilterSearchingBaseViewModel {
    public FechaDesde: Date | null;
    public FechaHasta: Date | null;
    public IdProvincia: number | null;
    public IdProvinciaDescripcion = '';
    public IdPuntoInspeccion: number | null;
    public IdPuntoInspeccionDescripcion = '';
    public RazonSocial = '';

    public GenerarExcel = false;
}

/****  INFORME TASAS EXPORTACIÓN  ****/

export class InformeTasasExportacionItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: InformeTasasExportacionItemViewModel[];
}

export class InformeTasasExportacionItemViewModel {
    public CodigoTipoSolicitud: string;
    public NombreTipoSolicitudComplete: string;
    public IsPredua: boolean;
    public TipoSolicitud: string;
    public IdEstadoSolicitud: number;

    public Provincia: string;
    public PuntoInspeccion: string;
    public FechaSolicitud: Date;
    public Codigo: string;
    public EstadoSolicitud: string;
    public TotalTasas: number;
    public NumeroLiquidacion: string;
    public FechaLiquidacion: Date | null;
}

export class FilterSearchingInformeTasasExportacionViewModel extends FilterSearchingBaseViewModel {
    public FechaDesde: string;
    public FechaHasta: string;
    public IdProvincia: number | null;
    public IdProvinciaDescripcion = '';
    public IdPuntoInspeccion: number | null;
    public IdPuntoInspeccionDescripcion = '';
    public RazonSocial = '';
    public GenerarExcel = false;
}

/****  INFORME INSPECCIONES  ****/

export class InformeInspeccionesItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: InformeInspeccionesItemViewModel[];
}

export class InformeInspeccionesItemViewModel {
    public IdSolicitud: number;
    public Codigo: string;
    public CodigoTipoSolicitud: string;
    public NombreTipoSolicitudComplete: string;
    public IsPredua: boolean;
    public FechaEnvio: Date | null;
    public TipoSolicitud: string;
    public IdEstadoSolicitud: number;
    public EstadoSolicitud: string;
    public Provincia: string;
    public PuntoInspeccion: string;
    public CodigoTaric: string;
    public CodigoEppo: string;
    public Grupo: string;
    public Forma: string;
    public NombreCientifico: string;
    public PaisOrigen: string;
    public PaisProcedencia: string;
    public Matriculas: string;
    public NombreInspector: string;
    public Documental: boolean | null;
    public FechaDocumental: Date | null;
    public Identidad: boolean | null;
    public FechaIdentidad: Date | null;
    public Fisica: boolean | null;
    public FechaFisica: Date | null;
    public Decision: string;
    public FechaFinalizacion: Date | null;
    public Motivos: string;
    public Medidas: string;
    public Observaciones: string;

    //para las agrupaciones
    public CuentaSolicitudes: number;
    public Mes: number;
    public Año: number;
}

export class FilterSearchingInformeInspeccionesViewModel extends FilterSearchingBaseViewModel {
    public FechaDesde: Date | null;
    public FechaHasta: Date | null;
    public IdAgrupacionFechas: number;
    public IdAgrupacionFechasDescripcion: string;
    public IdTipoSolicitud: number | null;
    public IdTipoSolicitudDescripcion = '';
    public IdEstadoSolicitud: number | null;
    public IdEstadoSolicitudDescripcion = '';
    public IdProvincia: number | null;
    public IdProvinciaDescripcion = '';
    public IdPuntoInspeccion: number | null;
    public IdPuntoInspeccionDescripcion = '';
    public IdPaisOrigen: number | null;
    public IdPaisOrigenDescripcion = '';
    public IdPaisOrigenGrupoPaisFr: number | null;
    public IdPaisOrigenGrupoPaisFrDescripcion = '';
    public IdPaisProcedenciaCollection: number[] | null;
    public IdPaisProcedenciaDescripcion = '';
    public IdPaisProcedenciaGrupoPaisFrCollection: number[] | null;
    public IdPaisProcedenciaGrupoPaisFrDescripcion = '';
    public IdGrupo: number | null;
    public IdGrupoDescripcion = '';
    public IdForma: number | null;
    public IdFormaDescripcion = '';
    public IdSubForma: number | null;
    public IdSubFormaDescripcion = '';
    public CodigoEppoCollection: number[] = [];
    public CodigoEppoDescripcionCollection: string[] = [];
    public CodigoTaric = '';
    public IdDecision: number | null;
    public IdDecisionDescripcion = '';
    public IdMotivo: number | null;
    public IdMotivoDescripcion = '';
    public IdMedida: number | null;
    public IdMedidaDescripcion = '';

    public GenerarExcel = false;
}

/****  INFORME INSPECCIONES EXPORTACION  ****/

export class InformeInspeccionesExportacionItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: InformeInspeccionesExportacionItemViewModel[];
}

export class InformeInspeccionesExportacionItemViewModel {
    public IdSolicitud: number;
    public Codigo: string;
    public CodigoTipoSolicitud: string;
    public NombreTipoSolicitudComplete: string;
    public IsPredua: boolean;
    public FechaEnvio: Date | null;
    public TipoSolicitud: string;
    public IdEstadoSolicitud: number;
    public EstadoSolicitud: string;
    public Provincia: string;
    public PuntoInspeccion: string;
    public CodigoTaric: string;
    public CodigoEppo: string;
    public Grupo: string;
    public Forma: string;
    public NombreCientifico: string;
    public PaisOrigen: string;
    public PaisProcedencia: string;
    public Matriculas: string;
    public NombreInspector: string;
    public Documental: boolean | null;
    public FechaDocumental: Date | null;
    public Identidad: boolean | null;
    public FechaIdentidad: Date | null;
    public Fisica: boolean | null;
    public FechaFisica: Date | null;
    public Decision: string;
    public FechaFinalizacion: Date | null;
    public Motivos: string;
    public Medidas: string;
    public Observaciones: string;

    //para las agrupaciones
    public CuentaSolicitudes: number;
    public Mes: number;
    public Año: number;
}

export class FilterSearchingInformeInspeccionesExportacionViewModel extends FilterSearchingBaseViewModel {
    public FechaDesde: Date | null;
    public FechaHasta: Date | null;
    public IdAgrupacionFechas: number;
    public IdAgrupacionFechasDescripcion: string;
    public IdTipoSolicitud: number | null;
    public IdTipoSolicitudDescripcion = '';
    public IdEstadoSolicitud: number | null;
    public IdEstadoSolicitudDescripcion = '';
    public IdProvincia: number | null;
    public IdProvinciaDescripcion = '';
    public IdPuntoInspeccion: number | null;
    public IdPuntoInspeccionDescripcion = '';
    public IdPaisOrigen: number | null;
    public IdPaisOrigenDescripcion = '';
    public IdPaisOrigenGrupoPaisFr: number | null;
    public IdPaisOrigenGrupoPaisFrDescripcion = '';
    public IdPaisProcedencia: number | null;
    public IdPaisProcedenciaDescripcion = '';
    public IdPaisProcedenciaGrupoPaisFr: number | null;
    public IdPaisProcedenciaGrupoPaisFrDescripcion = '';
    public IdGrupo: number | null;
    public IdGrupoDescripcion = '';
    public IdForma: number | null;
    public IdFormaDescripcion = '';
    public IdSubForma: number | null;
    public IdSubFormaDescripcion = '';
    public CodigoEppoCollection: number[] = [];
    public CodigoEppoDescripcionCollection: string[] = [];
    public CodigoTaric = '';
    public IdDecision: number | null;
    public IdDecisionDescripcion = '';
    public IdMotivo: number | null;
    public IdMotivoDescripcion = '';
    public IdMedida: number | null;
    public IdMedidaDescripcion = '';
    public GenerarExcel = false;
}

export enum EnumIdsInformeInspeccionesAgrupacionFechas {
    ID_SIN_AGRUPAR = 1,
    ID_MES = 2,
    ID_ANIO = 3,
}

export enum EnumIdsTcInformesGenerales {
    INFORME_TASAS = 2,
    INFORME_TASAS_EXPORTACION = 4,

    //INFORME_GENERAL_BUSQUEDA = 5,
}

export enum EnumIdsTcInformesEstadisticos {
    INFORME_INSPECCIONES = 3,
    INFORME_IMPORTACIONES = 1,
    INFORME_EXPORTACIONES = 5,
    INFORME_INSPECCIONES_EXPORTACION = 6,

    //INFORME_GENERAL_BUSQUEDA = 5,
}

export enum EnumIdsTwTcTipoInforme {
    ID_GENERAL = 1,
    ID_ESTADISTICO = 2,
}
